import React, { useEffect } from 'react';
import { getAllForms, getFormConfig, formRegistry } from '../forms';
import { Link } from 'react-router-dom';

const DebugPage = () => {
  useEffect(() => {
    console.log('=== COMPLETE FORM SYSTEM DEBUG ===');
    console.log('Full registry:', formRegistry);
    console.log('All forms:', getAllForms());
  }, []);
  
  const forms = getAllForms();
  
  return (
    <div className="container py-8">
      <h1 className="text-2xl font-bold mb-6">Form System Debug</h1>
      
      <div className="card mb-8">
        <h3 className="text-lg font-semibold mb-4">Registry Status</h3>
        <p className="mb-4">Total forms: {forms.length}</p>
        <div className="bg-gray-100 p-4 rounded overflow-auto max-h-96 text-xs font-mono">
          <pre>{JSON.stringify(formRegistry, (key, value) => {
            if (typeof value === 'function') return `[Function: ${value.name || 'anonymous'}]`;
            if (typeof value === 'object' && value !== null && value.$$typeof) return '[React Component]';
            return value;
          }, 2)}</pre>
        </div>
      </div>
      
      <div className="space-y-4 mb-8">
        <h3 className="text-lg font-semibold">Individual Form Checks</h3>
        {Object.keys(formRegistry || {}).map(formId => {
          const config = getFormConfig(formId);
          return (
            <div key={formId} className={`p-4 rounded border ${config ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="font-bold">{formId} {config ? '✅' : '❌'}</h4>
                  {config ? (
                    <div className="text-sm mt-2 space-y-1">
                      <p>Name: {config.name}</p>
                      <p>Component: {config.component ? (config.component.name || 'Present (Anonymous)') : 'Missing'}</p>
                      <p>PDF Component: {config.pdfComponent ? (config.pdfComponent.name || 'Present') : 'Missing'}</p>
                    </div>
                  ) : (
                    <p className="text-red-600">Form not found in registry</p>
                  )}
                </div>
                {config && (
                  <Link 
                    to={`/forms/${formId}`}
                    className="btn btn-sm btn-primary text-xs"
                  >
                    Test Form
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="flex gap-4">
        <button 
          onClick={() => window.location.reload()}
          className="btn btn-secondary"
        >
          Reload Page
        </button>
        <Link 
          to="/forms"
          className="btn btn-primary"
        >
          Go to Form Library
        </Link>
      </div>
    </div>
  );
};

export default DebugPage;